import { FaHtml5, FaCss3Alt, FaFilePdf, FaMarkdown, FaReact, FaPython, FaJava, FaDatabase, FaRust, FaRegFileAlt } from 'react-icons/fa';
import { SiTypescript, SiJson, SiYaml, SiCplusplus, SiJavascript, SiDocker, SiRuby } from 'react-icons/si';
import { FaFileCsv, FaGitAlt, FaGolang, FaMicrochip, FaNpm, FaRProject } from 'react-icons/fa6';
import { VscCode, VscTerminal, VscTerminalBash, VscFolderOpened, VscFolder, VscNewFolder, VscNewFile, VscTrash, VscEdit } from 'react-icons/vsc';

const iconsMap = {
    folderOpen: { icon: <VscFolderOpened style={{ color: 'inherit' }} />, language: null },
    folderClosed: { icon: <VscFolder style={{ color: 'inherit' }} />, language: null },
    addFolder: { icon: <VscNewFolder style={{ color: 'inherit' }} />, language: null },
    addFile: { icon: <VscNewFile style={{ color: 'inherit' }} />, language: null },
    edit: { icon: <VscEdit style={{ color: 'inherit' }} />, language: null },
    delete: { icon: <VscTrash style={{ color: 'inherit' }} />, language: null },
    js: { icon: <SiJavascript style={{ color: '#f0db4f' }} />, language: 'javascript' },
    ts: { icon: <SiTypescript style={{ color: '#3178C6' }} />, language: 'typescript' },
    jsx: { icon: <FaReact style={{ color: '#196fff' }} />, language: 'javascript' },
    tsx: { icon: <FaReact style={{ color: '#196fff' }} />, language: 'typescript' },
    json: { icon: <SiJson style={{ color: '#967bb6' }} />, language: 'json' },
    bash: { icon: <VscTerminalBash style={{ color: '#4EAA25' }} />, language: 'shell' },
    exe: { icon: <VscTerminal style={{ color: '#333' }} />, language: 'shell' },
    sh: { icon: <VscTerminal style={{ color: '#4EAA25' }} />, language: 'shell' },
    zsh: { icon: <VscTerminalBash style={{ color: '#4EAA25' }} />, language:'shell' },
    yaml: { icon: <SiYaml style={{ color: '#1E2A3E' }} />, language: 'yaml' },
    css: { icon: <FaCss3Alt style={{ color: '#264de4' }} />, language: 'css'},
    html: { icon: <FaHtml5 style={{ color: '#e44d26' }} />, language: 'html' },
    py: { icon: <FaPython style={{ color: '#199ccc' }} />, language: 'python' },
    pdf: { icon: <FaFilePdf style={{ color: '#e3342f' }} />, language: null },
    md: { icon: <FaMarkdown style={{ color: '#0a0a0a' }} />, language: 'markdown' },
    txt: { icon: <FaRegFileAlt style={{ color: '#333' }} />, language: 'plaintext' },
    csv: { icon: <FaFileCsv style={{ color: '#00ab41' }} />, language: null },
    java: { icon: <FaJava style={{ color: '#f89820' }} />, language: 'java' },
    sql: { icon: <FaDatabase style={{ color: '#F4B400' }} />, language: 'sql' },
    cpp: { icon: <SiCplusplus style={{ color: '#5C2D91' }} />, language: 'cpp' },
    rs: { icon: <FaRust style={{ color: '#dea584' }} />, language: 'rust' },
    go: { icon: <FaGolang style={{ color: '#00ADD8' }} />, language: 'go' },
    asm: { icon: <FaMicrochip style={{ color: '#222' }} />, language: null },
    gitignore: { icon: <FaGitAlt style={{ color: '#f1502f' }} />, language: null },
    dockerfile: { icon: <SiDocker style={{ color: '#1D63ED' }} />, language: 'dockerfile' },
    rb: { icon: <SiRuby style={{ color: '#D50032' }} />, language:'ruby' },
    r: { icon: <FaRProject style={{ color: '#276DC3' }} />, language: 'r' },
    xml: { icon: <VscCode style={{ color: '#FF4000' }} />, language: 'xml' },
    default: { icon: <FaRegFileAlt style={{ color: '#333' }} />, language: 'plaintext' },
    npm: { icon: <FaNpm style={{ color: '#cb3837' }} />, language: null },
};

export const getFileIcon = (fileName, iconList = iconsMap) => {

    const lowerCaseFileName = fileName.toLowerCase();
    const ext = fileName.split('.').pop().toLowerCase();

    switch (lowerCaseFileName) {
        case 'dockerfile':
        case 'docker-compose.yaml':
            return iconList.dockerfile.icon || iconList.default.icon;
        case 'folderopen':
            return iconList.folderOpen.icon || iconList.default.icon;
        case 'folderclosed':
            return iconList.folderClosed.icon || iconList.default.icon;
        case 'addfolder':
            return iconList.addFolder.icon;
        case 'addfile':
            return iconList.addFile.icon;
        case 'delete':
            return iconList.delete.icon;
        case 'package.json':
        case 'package-lock.json':
            return iconList.npm.icon;
        default:
            return iconList[ext]?.icon || iconList.default.icon;
    }

   
};

export const getFileLanguage = (fileName, langList = iconsMap) => {

    const ext = fileName.split('.').pop().toLowerCase();
    return langList[ext]?.language || langList.default.language;
}
